// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*===== latest-news-area =====*/
::ng-deep .latest-news-area .single-news {
  margin-top: 30px;
}
::ng-deep .latest-news-area .single-news .image {
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
}
::ng-deep .latest-news-area .single-news .image img.article {
  min-height: 205px;
}
::ng-deep .latest-news-area .single-news .image img {
  height: 100%;
  width: 100%;
  transition: all 0.4s ease;
}
::ng-deep .latest-news-area .single-news .image .meta-details {
  display: inline-block;
  padding: 6px 15px 6px 7px;
  border-radius: 30px;
  background-color: var(--primary);
  position: absolute;
  right: 20px;
  bottom: 20px;
}
::ng-deep .latest-news-area .single-news .image .meta-details img {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  display: inline-block;
}
::ng-deep .latest-news-area .single-news .image .meta-details span {
  color: var(--white);
  display: inline-block;
  margin-left: 10px;
  font-size: 10px !important;
  font-weight: 500;
}
::ng-deep .latest-news-area .single-news .content-body .title {
  margin: 1rem 0 1rem 0 !important;
  min-height: 62px;
  max-height: 62px;
}
::ng-deep .latest-news-area .single-news .content-body .title a {
  color: var(--accent);
  transition: all 0.3s ease-out 0s;
  font-size: 24px !important;
  cursor: pointer;
}
::ng-deep .latest-news-area .single-news .content-body .title a:hover {
  color: var(--dark-2);
}
::ng-deep .latest-news-area .single-news .content-body p {
  color: var(--dark-2);
}
::ng-deep .latest-news-area .single-news:hover .image .thumb {
  transform: scale(1.1) rotate(1deg);
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  ::ng-deep .latest-news-area .single-news .content-body .title {
    margin: 20px 0 10px 0;
    height: auto !important;
    min-height: unset !important;
    max-height: unset !important;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) and (max-width: 767px) {
  ::ng-deep .latest-news-area .single-news .content-body .title {
    margin: 20px 0 10px 0;
    height: 22px;
    min-height: 22px;
    max-height: 22px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  ::ng-deep .latest-news-area .single-news .content-body .title {
    margin: 1rem 0 1rem 0 !important;
    height: 32px;
    min-height: 32px;
    max-height: 32px;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .latest-news-area .single-news .content-body .title {
    margin: 1rem 0 1rem 0 !important;
    min-height: 62px;
    max-height: 62px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/common/news/news.component.scss"],"names":[],"mappings":"AAAA,+BAAA;AAEE;EACE,gBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AAGE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;AADJ;AAGE;EACE,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AADJ;AAGE;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AADJ;AAGE;EACE,gCAAA;EACA,gBAAA;EACA,gBAAA;AADJ;AAGE;EACE,oBAAA;EAKA,gCAAA;EACA,0BAAA;EACA,eAAA;AADJ;AAGE;EACE,oBAAA;AADJ;AAGE;EACE,oBAAA;AADJ;AAGE;EACE,kCAAA;AADJ;;AAMA,iDAAA;AACA;EAEI;IACE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,4BAAA;EAJJ;AACF;AAQA,oEAAA;AACA;EAEI;IACE,qBAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;EAPJ;AACF;AAWA,qDAAA;AACA;EAEI;IACE,gCAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;EAVJ;AACF;AAcA,mDAAA;AAGA,oEAAA;AACA;EACI;IACE,gCAAA;IACE,gBAAA;IACA,gBAAA;EAdN;AACF","sourcesContent":["/*===== latest-news-area =====*/\n::ng-deep {\n  .latest-news-area .single-news {\n    margin-top: 30px;\n  }\n  .latest-news-area .single-news .image {\n    position: relative;\n    border-radius: .5rem;\n    overflow: hidden;\n\n    img.article {\n      min-height: 205px;\n    }\n  }\n  .latest-news-area .single-news .image img {\n    height: 100%;\n    width: 100%;\n    transition: all 0.4s ease;\n  }\n  .latest-news-area .single-news .image .meta-details {\n    display: inline-block;\n    padding: 6px 15px 6px 7px;\n    border-radius: 30px;\n    background-color: var(--primary);\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n  }\n  .latest-news-area .single-news .image .meta-details img {\n    height: 28px;\n    width: 28px;\n    border-radius: 50%;\n    display: inline-block;\n  }\n  .latest-news-area .single-news .image .meta-details span {\n    color: var(--white);\n    display: inline-block;\n    margin-left: 10px;\n    font-size: 10px !important;\n    font-weight: 500;\n  }\n  .latest-news-area .single-news .content-body .title {\n    margin: 1rem 0 1rem 0 !important;\n    min-height: 62px;\n    max-height: 62px;\n  }\n  .latest-news-area .single-news .content-body .title a {\n    color: var(--accent);\n    -webkit-transition: all 0.3s ease-out 0s;\n    -moz-transition: all 0.3s ease-out 0s;\n    -ms-transition: all 0.3s ease-out 0s;\n    -o-transition: all 0.3s ease-out 0s;\n    transition: all 0.3s ease-out 0s;\n    font-size: 24px !important;\n    cursor: pointer;\n  }\n  .latest-news-area .single-news .content-body .title a:hover {\n    color: var(--dark-2);\n  }\n  .latest-news-area .single-news .content-body p {\n    color: var(--dark-2);\n  }\n  .latest-news-area .single-news:hover .image .thumb {\n    transform: scale(1.1) rotate(1deg);\n  }\n}\n\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n  ::ng-deep {\n    .latest-news-area .single-news .content-body .title {\n      margin: 20px 0 10px 0;\n      height: auto !important;\n      min-height: unset !important;\n      max-height: unset !important;\n    }\n  }\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) and (max-width: 767px) {\n  ::ng-deep {\n    .latest-news-area .single-news .content-body .title {\n      margin: 20px 0 10px 0;\n      height: 22px;\n      min-height: 22px;\n      max-height: 22px;\n    }\n  }\n}\n\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  ::ng-deep {\n    .latest-news-area .single-news .content-body .title {\n      margin: 1rem 0 1rem 0 !important;\n      height: 32px;\n      min-height: 32px;\n      max-height: 32px;\n    }\n  }\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {\n    .latest-news-area .single-news .content-body .title {\n      margin: 1rem 0 1rem 0 !important;\n        min-height: 62px;\n        max-height: 62px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
